import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	contributorsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	contributorsLabel: {
		id: 'software-releases-launch-card.version-contributors.contributors-label',
		defaultMessage: 'Contributors',
		description: 'Label of the contributors field inside Launch Card',
	},
});
export default messages;
